exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-9879ec86] .el-tabs__nav-scroll{padding:0 10px}.acc-root-sty[data-v-9879ec86]{padding:5px 10px}.acc-root-sty .search_box[data-v-9879ec86]{margin:20px 0;text-align:right}.acc-root-sty .link-option[data-v-9879ec86]{color:#290202;font-weight:700}.acc-root-sty .pageation[data-v-9879ec86]{padding:30px 10px 20px;border-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9879ec86","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/signSettings/components/account/index.vue
// module id = WKtp
// module chunks = 0 84 97